import _extends from "@babel/runtime/helpers/extends";
import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
import React from 'react';
import { Header, Button } from 'semantic-ui-react';
import Event from '../../darkmatter/Event';
import IconElement from '../IconElement';

var ContactElement = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(ContactElement, _React$Component);

  function ContactElement() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ContactElement.prototype;

  _proto.renderLink = function renderLink() {
    var _this$props = this.props,
        contact = _this$props.contact,
        link = _this$props.link,
        iconType = _this$props.iconType,
        as = _this$props.as,
        iconPosition = _this$props.iconPosition,
        buttonColor = _this$props.buttonColor,
        fluidButton = _this$props.fluidButton,
        buttonSize = _this$props.buttonSize; // Button use case

    var iconProps = iconType === 'none' ? {} : {
      icon: iconType
    };
    var contentProps = as === 'icon' ? {} : {
      content: contact
    };
    var isPrimary = buttonColor === 'primary';
    var buttonColorProps = isPrimary ? {
      primary: true
    } : {
      secondary: true
    };

    if (as === 'text') {
      var header = /*#__PURE__*/React.createElement("a", {
        href: link
      }, /*#__PURE__*/React.createElement("p", null, contact));
      var textContent = iconType === 'none' || iconType === '' ? header : /*#__PURE__*/React.createElement(IconElement, {
        iconType: iconType,
        element: header,
        iconPosition: iconPosition
      });
      return /*#__PURE__*/React.createElement(Event, {
        event: {
          category: 'Contact',
          action: 'click',
          label: link
        },
        eventType: "click"
      }, textContent);
    }

    return /*#__PURE__*/React.createElement(Event, {
      event: {
        category: 'Contact',
        action: 'click',
        label: link
      },
      eventType: "click"
    }, /*#__PURE__*/React.createElement(Button, _extends({
      fluid: fluidButton,
      size: buttonSize,
      as: "a",
      href: link
    }, buttonColorProps, contentProps, iconProps)));
  };

  _proto.renderHeader = function renderHeader() {
    var header = this.props.header;
    return /*#__PURE__*/React.createElement(Header, {
      as: "h2"
    }, header);
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        className = _this$props2.className,
        header = _this$props2.header;
    return header !== '' ? /*#__PURE__*/React.createElement("div", {
      className: className
    }, this.renderHeader(), this.renderLink()) : /*#__PURE__*/React.createElement("div", {
      className: className
    }, this.renderLink());
  };

  return ContactElement;
}(React.Component);

export { ContactElement as default };
ContactElement.defaultProps = {
  as: 'text',
  buttonColor: 'primary',
  buttonSize: 'large',
  className: '',
  fluidButton: false,
  header: '',
  iconPosition: 'left',
  iconType: 'none'
};